/**
	* Licensed Materials - Property of IBM
	* IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2020
	* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
	*/
define(['./FilterTable',
	'./FilterTypes',
	'../FilterMetadataHelper'
],function ( FilterTable, FILTER_TYPES, MetadataHelper) {
	'use strict';

	function FilterModuleFinder (){}

	/**
	*
	* Return the appropriate filter controller module for instantiation by the caller.
	*
	* @param {String} options.origin - The creator of the filter instance. Example:
	* filterDock, localFilter
	* @param {String} options.isHierarchy - True if the filter instance is for a hierarchy
	* @param {String} options.dataType - Data type for the filter item. Example "DATE"
	* @param {String} options.usage - usage type for the filter item. Example "attribute"
	*
	* Example usage:
	* var module =  FilterModuleFinder.getModule({
	*		origin: 'filterDock',
	*		isHierarchy: false,
	*		dataType: INTEGER,
	*		usage: 'fact'
	* });
	*/
	FilterModuleFinder.getModule = function(options){
		var controlType, origin;
		var dataType = options.dataType;
		var usage = options.usage;
		var isHierarchy = (options.isHierarchy === undefined) ? null : options.isHierarchy;

		var metadataPromise;
		if (!dataType || !usage || isHierarchy === null) {
			metadataPromise = MetadataHelper.getColumnMetadataInfo(options.dataSources, options.sourceId, options.itemId);
		} else {
			metadataPromise = Promise.resolve({
				dataType: dataType.toLowerCase(),
				usage: usage,
				isHierarchy: isHierarchy
			});
		}

		const _isDateTimeFilter = (options) => {
			if(MetadataHelper.isDateType(dataType)) {
				// global filter
				if(options.origin === 'filterDock') {
					// There is a special case for GLOBAL filter ONLY (It happens on drill through):
					// If it's a date time type without range then we should NOT return date time filter
					return options.isRange;
				}
				// local filter
				return true;
			}
			return false;
		};

		return metadataPromise.then(function(metadataInfo) {
			dataType = metadataInfo.dataType;
			usage = metadataInfo.usage;
			isHierarchy = metadataInfo.isHierarchy;

			//Since filter widget and filter dock use the same modules, create an alias
			origin = options.origin === 'filterWidget' ? 'filterDock' : options.origin;

			if (usage === 'fact') {
				// usage fact = range filter
				controlType = FILTER_TYPES.RANGE;
			} else {
				// usage attribute = non numeric, tree, or date time filter (isRange true)
				controlType = _isDateTimeFilter(options) ? FILTER_TYPES.DATE_TIME : (isHierarchy ? FILTER_TYPES.TREE : FILTER_TYPES.NON_NUMERICAL);
			}
			if (options.origin==='localFilter') {
				//For local filters, dialog ui is implemented in paths inside the LocalFiltersUI feature
				//of the dataFilters component.
				if (options.content && options.content.getFeature('LocalFiltersUI')) {
					const localFiltersUI = options.content.getFeature('LocalFiltersUI');
					return localFiltersUI.getLocalFilterUI(controlType).path;
				}
				return { path: null };
			}
			//Origin='filterDock'
			return FilterTable[origin][controlType].path;
		});
	};

	return FilterModuleFinder;
});
